module.exports = __webpack_public_path__ + "static/media/circle_blur_blue@2x.5898fb75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/greeting/circle_blur_blue@2x.png
// module id = 402
// module chunks = 0